/* rd-configurator.js — RD 描述内配置器「无跳动」轮子 (2026-09-22)
   适用: 描述里用 CSS :target + <a href="#id"> 做的款式/头数/子款切换 (.rd-pdp.rdc / .rdc-panel / .rdc-anchor …, 以及任何 data-rdc 容器)。
   原理: 锚点跳转是浏览器规范行为, 纯 CSS 无法禁止 → 本脚本把容器相关 <style> 里的 ":target" 改写为 ".rdc-t",
   点击时 preventDefault, 只在容器内把 .rdc-t 挂到目标元素(同一时刻只有一个, 与 :target 语义一致), URL/滚动位置都不动。
   带 #hash 打开页面时仍按 hash 初始化(深链接照常)。幂等, Honey 重渲染 product-information 后自动重跑。零依赖。
   接入: 主题全局加载(product-information.liquid) → 现有/新品描述不用改任何代码; 或把本文件内容包在 <script> 里贴进描述末尾亦可。 */
(function () {
  'use strict';
  var CLS = 'rdc-t';
  var SEL = '.rd-pdp.rdc, [data-rdc]';
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function rewriteStyles() {
    $$('style').forEach(function (st) {
      if (st.dataset.rdcT) return;
      var t = st.textContent;
      if (t.indexOf(':target') < 0 || !/rdc-|data-rdc|\[data-rdc\]/.test(t)) return;
      st.textContent = t.replace(/:target\b/g, '.' + CLS);
      st.dataset.rdcT = '1';
    });
  }
  function setTarget(root, el) {
    $$('.' + CLS, root).forEach(function (x) { x.classList.remove(CLS); });
    if (el) el.classList.add(CLS);
  }
  function upgrade(root) {
    if (root.dataset.rdcNoJump) return;
    root.dataset.rdcNoJump = '1';
    // 初始状态: 带 hash 打开 → 按 hash; 否则 CSS 默认(第一块面板)
    var h = location.hash ? decodeURIComponent(location.hash.slice(1)) : '';
    var init = h && document.getElementById(h);
    if (init && root.contains(init)) setTarget(root, init);
    root.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a || !root.contains(a)) return;
      var id = a.getAttribute('href').slice(1);
      var t;
      try { t = id && document.getElementById(decodeURIComponent(id)); } catch (_) { t = null; }
      if (!t || !root.contains(t)) return;           // 指向容器外的锚点 → 交给浏览器
      e.preventDefault();
      var y = window.pageYOffset;
      setTarget(root, t);
      if (window.pageYOffset !== y) window.scrollTo(0, y); // 双保险: 面板高度变化也不让视口跑
    }, true);
  }
  function boot() {
    var roots = $$(SEL);
    if (!roots.length) return;
    rewriteStyles();
    roots.forEach(function (r) { try { upgrade(r); } catch (e) { } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 100); });
  if (window.MutationObserver) {
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(boot, 200); }).observe(document.documentElement, { childList: true, subtree: true });
  }
  window.__rdConfigurator = { boot: boot, v: '1.0' };
})();
